import { createObserver } from '../../components/observer-factory';

const productDetailButtonObserver = createObserver(0.7);

document.addEventListener('DOMContentLoaded', () => {
  const product_detail_sticky_bottom = document.getElementById('product-detail-sticky-bottom'),
  product_detail_button = document.getElementById('product-detail-button');
  productDetailButtonObserver.observe(product_detail_button);

  product_detail_button.addEventListener('intersecting', () => {
    product_detail_sticky_bottom.classList.add('product-detail-sticky-bottom-is-hidden');
  });

  product_detail_button.addEventListener('not-intersecting', () => {
    product_detail_sticky_bottom.classList.remove('product-detail-sticky-bottom-is-hidden');
  });
});